import ticketNotification from "./ticketNotification.component";

const ticketNotificationModule = angular
  .module("app.components.ticketNotification", [])
  .component("ticketNotification", ticketNotification);

export default ticketNotificationModule;



// WEBPACK FOOTER //
// ./src/components/ticketNotification/ticketNotification.module.js